module.exports = __webpack_public_path__ + "static/img-appicon-large.f8bea865.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/img-appicon-large.png
// module id = 458
// module chunks = 915738553496